import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function TestimonialFooter() {
  return <footer className="py-20 bg-brown text-cream-alt text-center px-6 md:px-8" data-id="element-134">
      <div className="max-w-3xl mx-auto" data-id="element-135">
        <FadeIn data-id="element-136">
          <img src="https://cdn.magicpatterns.com/uploads/t6comzhc55deJhE92CpNH6/freepik__professional-minimalist-studio-portrait-of-a-young__94277.png" alt="Con mi hija Rafi" className="w-32 h-32 rounded-full object-cover object-top mx-auto mb-6 border-4 border-gold/30 shadow-lg" data-id="element-137" />
          <div className="text-gold/30 text-6xl font-heading leading-none mb-4" data-id="element-138">
            "
          </div>
          <p className="text-xl md:text-2xl font-heading italic leading-relaxed mb-8" data-id="element-139">
            No soy una gurú de la felicidad. Soy una mamá en las trincheras,
            como tú, que encontró la salida y decidió documentar el camino para
            que ninguna otra madre tenga que sentirse sola en el caos.
          </p>
          <div className="w-12 h-px bg-gold/50 mx-auto mb-8" data-id="element-140" />
          <p className="text-sm text-cream/60 tracking-wider uppercase" data-id="element-141">
            De Caos a Calma &copy; {new Date().getFullYear()}
          </p>
        </FadeIn>
      </div>
    </footer>;
}